import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { TestPageComponent } from './components/testpage.component';
import { LazyElementsModule } from '@angular-extensions/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TestPageComponent2 } from './components/testpage2/testpage2.component';

@NgModule({
  declarations: [
    TestPageComponent,
    TestPageComponent2
  ],
  imports: [
    CommonModule,
    SharedModule,
    LazyElementsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PocModule { }
